/* global  */ // tUrl等のグローバル変数を宣言する
import scrollLock from './functions/_scrollLock.js' // スクロールロック

import './module/_hashScroll' // アンカーリンクスクロール
import './module/_spMenuToggle' // SPメニュー開閉
import './module/_toast' // トースト通知

import './_api'
import './_ajax'

import './_top'
import './_lang'
import './_ppv'
import './_content'
import './_review'
import './_product'
import './_video'
import './_cart'
import './_form'

import { Autoplay, Controller, EffectFade, Navigation, Pagination, Swiper } from 'swiper'
Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言

// import 'core-js/features/number/is-nan' // SwiperのIE対応
// import 'custom-event-polyfill' // SwiperのIE対応
// import { Autoplay, Controller, EffectFade, Navigation, Pagination, Swiper } from 'swiper'
// Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,

/*
 ##     ## ##     ##          ######  ##    ## ##    ##  ######
 ##     ## ##     ##         ##         ####   ####  ## ##
 ######### ##     ## #######  ######     ##    ## ## ## ##
 ##     ##  ##   ##                ##    ##    ##  #### ##
 ##     ##    ###             ######     ##    ##    ##  ######
ホバー中、その要素とその連動要素全てに.hoverを付与

<a href="" class="js-hoverSync js-hoverSync--hoge" data-hover-sync="hoge"></a>
<a href="" class="js-hoverSync js-hoverSync--hoge" data-hover-sync="hoge"></a>
*/
const hoverSyncClass = 'js-hoverSync'
if (document.getElementsByClassName(hoverSyncClass)[0]) {
  hoverSync()
}
function hoverSync() {
  const hoverActiveClass = 'hover'
  const hoverItems = document.getElementsByClassName(hoverSyncClass)
  for (let index = 0; index < hoverItems.length; index++) {
    const hoverItem = hoverItems[index]
    const hoverTargets = document.getElementsByClassName(hoverSyncClass + '--' + hoverItem.dataset.hoverSync)
    hoverItem.addEventListener(
      'mouseover',
      function () {
        for (let index = 0; index < hoverTargets.length; index++) {
          hoverTargets[index].classList.add(hoverActiveClass)
        }
      },
      false
    )
    hoverItem.addEventListener(
      'mouseout',
      function () {
        for (let index = 0; index < hoverTargets.length; index++) {
          hoverTargets[index].classList.remove(hoverActiveClass)
        }
      },
      false
    )
  }
}

//   ####  #####  ##                    ##  ##   ##  ###    ###  #####
//  ##     ##     ##                    ##  ##   ##  ## #  # ##  ##  ##
//   ###   #####  ##      ########      ##  ##   ##  ##  ##  ##  #####
//     ##  ##     ##                ##  ##  ##   ##  ##      ##  ##
//  ####   #####  ######             ####    #####   ##      ##  ##
// セレクトボックスで選んだURLにジャンプする
const selectJump = document.getElementsByClassName('js-selectJump')
if (selectJump[0]) {
  window.addEventListener('change', function (e) {
    if (!e.target.classList.contains('js-selectJump')) {
      return
    }
    window.location.href = e.target.value
  })
}

//  ###    ###   #####   ####      ###    ##
//  ## #  # ##  ##   ##  ##  ##   ## ##   ##
//  ##  ##  ##  ##   ##  ##  ##  ##   ##  ##
//  ##      ##  ##   ##  ##  ##  #######  ##
//  ##      ##   #####   ####    ##   ##  ######

const modalOverlay = document.getElementById('modalOverlay') // モーダル用オーバーレイ
const modals = document.getElementsByClassName('js-modal') // モーダル本体
if (modals[0]) {
  window.addEventListener('click', (e) => {
    if (!e.target.closest('.js-modal-open')) {
      return
    }
    e.preventDefault()
    modalClose()
    const target = e.target.closest('.js-modal-open').dataset.modal

    const openModals = document.querySelectorAll('.js-modal--' + target)
    for (const openModal of openModals) {
      openModal.classList.add('active')
    }

    modalOverlay.classList.add('active')
    scrollLock('body', '#modalOverlay')
  })
  // モーダル撤去
  window.addEventListener('click', (e) => {
    if (!e.target.closest('.js-modal-close')) {
      return
    }
    e.preventDefault()
    modalClose()
    modalOverlay.classList.remove('active')
    scrollLock('body', '#modalOverlay')
  })
}

function modalClose() {
  // モーダルを消す
  for (let index = 0; index < modals.length; index++) {
    const modal = modals[index]
    modal.classList.remove('active')
  }
}

/*
  ######          ########  #######   ######    ######   ##       ########
 ##                  ##    ##     ## ##        ##        ##       ##
 ##       #######    ##    ##     ## ##   #### ##   #### ##       ######
 ##                  ##    ##     ## ##    ##  ##    ##  ##       ##
  ######             ##     #######   ######    ######   ######## ########

// クリックされたとき、属するグループのクラスを反転させる
<button type="button" class="js-clickToggle" data-toggle-group="hogeGroup"></button>
<div class="js-clickToggle--hogeGroup"></div>

*/
window.addEventListener('click', function (e) {
  if (!e.target.classList.contains('js-clickToggle')) {
    return
  }
  const group = e.target.dataset.toggleGroup
  toggleGroup(group, 'active')
})

function toggleGroup(group, className = 'active') {
  const hide = document.getElementsByClassName('js-clickToggle--' + group)
  for (let index = 0; index < hide.length; index++) {
    hide[index].classList.toggle(className)
  }
}

//   ####            ######   #####     ###     ####  ######
//  ##                 ##    ##   ##   ## ##   ##       ##
//  ##     ########    ##    ##   ##  ##   ##   ###     ##
//  ##                 ##    ##   ##  #######     ##    ##
//   ####              ##     #####   ##   ##  ####     ##
/*
<button type="button" class="js-clickToggle js-clickToggle--fav-<?php echo $productID; ?> js-api js-clickToast ppvFav__btn md-btn greenLine activeToggle" data-param="" data-toggle-group="fav-<?php echo $productID; ?>" data-info="fav" data-id="<?php echo $productID; ?>" data-toast-on="お気に入りに登録しました" data-toast-off="お気に入りから削除しました">
</button>
*/
window.addEventListener('click', function (e) {
  if (!e.target.classList.contains('js-clickToast')) {
    return
  }
  // .activeの有無でONOFFを判断　.js-clickToggleの処理が先に行われる前提
  if (e.target.classList.contains('active')) {
    window.popToast(e.target.dataset.toastOn)
  } else {
    window.popToast(e.target.dataset.toastOff)
  }
})

//   ####  #####              ####  #####    ###    #####     ####  ##   ##
//  ##     ##  ##            ##     ##      ## ##   ##  ##   ##     ##   ##
//   ###   #####   ########   ###   #####  ##   ##  #####    ##     #######
//     ##  ##                   ##  ##     #######  ##  ##   ##     ##   ##
//  ####   ##                ####   #####  ##   ##  ##   ##   ####  ##   ##

window.addEventListener('click', function (e) {
  // 指定のIDを持つ
  if (e.target.id === 'spSearch-open' || e.target.id === 'searchOverlay') {
    document.getElementById('spSearch').classList.toggle('active')
    document.getElementById('searchOverlay').classList.toggle('active')

    // ナビは閉じる
    document.getElementById('gNav').classList.remove('active')
    document.getElementById('overlay').classList.remove('active')
  }
})
